import * as React from "react";
import {Grid} from "@material-ui/core";
import {Colors} from "../../theme/colors";
import styled from "styled-components";
import {CustomBulbDashboardIcon} from "../ui-base/icons/custom-bulb-dashboard-icon";

interface Props {
    title: string;
    description: string;
}

export const InfoDashobardComponent: React.FC<Props> = ({title, description}) => (
    <StyledProfile item container direction={"column"} spacing={2}>
        <Grid item>
            <CustomBulbDashboardIcon style={{height: '40px', width: '40px', fill: Colors.lightPink}}/>
        </Grid>
        <Grid item>
            <StyledProfileH6>{title}</StyledProfileH6>
        </Grid>

        <Grid item>
            <StyledProfileP>{description}</StyledProfileP>
        </Grid>
    </StyledProfile>
);

const StyledProfile = styled(Grid)`
  background: ${Colors.lightViolet};
  border-radius: 4px;
  padding: 20px;
  border: 1px solid #E0E0E0;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.12));
`;

const StyledProfileH6 = styled('h6')`
  color: #fff;
  font-weight: 600;
  font-size: 1.5rem;
`;

const StyledProfileP = styled('p')`
  color: ${Colors.extraLightViolet};
`;
